import subTreatmentType from '@constants/subTreatmentType.constants'

export default [
  {
    label: 'Clear Aligners',
    value: subTreatmentType.ALIGNERS,
  },
]
